import { apiBaseUrl } from './platform.js';

/**
 * Links to the public pages the backend serves on the speak origin: the legal
 * pages (`public/legal/*.html`) and the support page (`GET /support`).
 *
 * - **Web**: the relative path, same origin as always.
 * - **Native**: the absolute `https` URL of the backend the build talks to
 *   (`apiBaseUrl()`, i.e. `VITE_NATIVE_API_URL`; it throws if the build lacks
 *   it, fail-fast). A relative link would resolve to the WebView's own origin:
 *   on iOS `capacitor://localhost/legal/…`, which `target="_blank"` hands to
 *   `UIApplication.open` and nothing happens. An absolute link to another host
 *   leaves the app through Capacitor's external-navigation path instead —
 *   Safari on iOS (`WebViewDelegationHandler`), an `ACTION_VIEW` intent on
 *   Android (`Bridge.launchIntent`) — the same way the coach's source links
 *   (`SourcesSheet`) open. Neither path is claimed by Universal Links
 *   (`APP_PATHS` in `apps/backend/src/routes/well-known.ts`), so they never
 *   bounce back into the app on iOS.
 *
 * Render them as `<a href={…} target="_blank" rel="noopener noreferrer">`.
 */
export type PublicPagePath = '/legal/privacidad.html' | '/legal/terminos.html' | '/support';

export function publicPageUrl(path: PublicPagePath): string {
  return `${apiBaseUrl()}${path}`;
}
